import React, { useState } from 'react';
import { leerDiagnosticoDeRed, borrarDiagnosticoDeRed } from '../../hooks/useFirestoreIdleManager';

/**
 * Lo que midió el gestor de red en ESTE teléfono (punto 10). Sólo con `?diagnosticoRed=1` en la bandeja: es para
 * leer en el iPhone, sin consola, si tras cada vuelta la bandeja volvió a oír al servidor. Interno, sin i18n.
 */
const RESULTADO = {
  ok: '✅ servidor', 'sin-servidor': '❌ sin servidor', 'sin-oyente': '— fuera de la bandeja', esperando: '⏳ esperando',
};
const hora = (iso) => { try { return new Date(iso).toLocaleString(); } catch (e) { return iso; } };

export default function DiagnosticoDeRed() {
  const [entradas, setEntradas] = useState(() => leerDiagnosticoDeRed().slice().reverse());
  const recargar = () => setEntradas(leerDiagnosticoDeRed().slice().reverse());
  return (
    <div style={{ margin: '0 0 1rem', padding: '0.75rem', border: '1px dashed #a0aec0', borderRadius: '8px', fontSize: '12px', background: '#f7fafc' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem', gap: '0.5rem' }}>
        <strong>Diagnóstico de red ({entradas.length})</strong>
        <span style={{ display: 'flex', gap: '0.4rem' }}>
          <button type="button" onClick={recargar}>Recargar</button>
          <button type="button" onClick={() => { borrarDiagnosticoDeRed(); recargar(); }}>Borrar</button>
        </span>
      </div>
      {entradas.length === 0 && <div>Sin registros todavía.</div>}
      {entradas.map((e) => (
        <div key={e.id} style={{ padding: '0.3rem 0', borderTop: '1px solid #e2e8f0', overflowWrap: 'anywhere' }}>
          <div>{hora(e.en)} · {e.evento}{e.tipo ? ` · ${e.tipo}` : ''}{e.motivo ? ` · ${e.motivo}` : ''}</div>
          {e.evento === 'reconexion' && (
            <div>
              fuera {Math.round((e.fueraMs || 0) / 1000)} s · {RESULTADO[e.resultado] || e.resultado}
              {e.resultado === 'ok' ? ` en ${(e.servidorTrasMs / 1000).toFixed(1)} s` : ''}
            </div>
          )}
          {e.error && <div style={{ color: '#c53030' }}>{e.paso ? `${e.paso}: ` : ''}{e.error}</div>}
        </div>
      ))}
    </div>
  );
}
